var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.643,
    height: 19.606,
    viewBox: "0 0 18.643 19.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-working-4407321",
    transform: "translate(-86.92 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12288",
    "data-name": "Path 12288",
    d: "M382.591,64.1a4.1,4.1,0,1,1-4.1-4.1,4.1,4.1,0,0,1,4.1,4.1",
    transform: "translate(-282.262 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12289",
    "data-name": "Path 12289",
    d: "M89.219,574.992l-2.178,6.165a2.043,2.043,0,0,0,1.939,2.723h1.612v-6.666a.53.53,0,0,1,.523-.523h10.261a.53.53,0,0,1,.523.523v6.666h1.612a2.063,2.063,0,0,0,1.939-2.745l-2.178-6.165a2.043,2.043,0,0,0-1.939-1.372h-3.05l-2.048,2.07-2.048-2.048H91.158a2.043,2.043,0,0,0-1.939,1.372Z",
    transform: "translate(0 -504.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12290",
    "data-name": "Path 12290",
    d: "M487.962,900a.763.763,0,0,0,0,1.525h2.571a.763.763,0,1,0,0-1.525Z",
    transform: "translate(-393.014 -824.751)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.bda18a0bb125b5a3e01894f835290d63.svg";
export { ForwardRef as ReactComponent };